(() => {
  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/helpers/helpers.js
  function getNextSibling(element, selector) {
    var sibling = element.nextElementSibling;
    if (!selector) {
      return sibling;
    }
    while (sibling) {
      if (sibling.matches(selector)) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }
  }
  function getTransitionEndEventName() {
    const transitions = {
      "transition": "transitionend",
      "OTransition": "oTransitionEnd",
      "MozTransition": "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    };
    let bodyStyle = document.body.style;
    for (let transition in transitions) {
      if (bodyStyle[transition] != void 0) {
        return transitions[transition];
      }
    }
  }

  // src/js/components/spacer.js
  var Spacer = class {
    constructor(navigation, element, next_sibling) {
      this.navigation = navigation;
      this.element = element;
      this.height = null;
      this.next_sibling = next_sibling;
    }
    static init() {
      const navigation = window.Store.components?.navigation?.obj ? window.Store.components.navigation.obj.elements.nav.element : null;
      const spacer = window.Store.app.theBody.querySelector(".js-spacer");
      if (!navigation || !spacer)
        return null;
      const navigation_height = window.Store.components.navigation.obj.elements.nav.element.getBoundingClientRect().height;
      const navigation_obj = {
        element: navigation,
        height: navigation_height
      };
      const header = window.Store.app.theBody.querySelector("js-header");
      const next_sibling = header ? header : getNextSibling(spacer, ":not(link)");
      const obj = new Spacer(navigation_obj, spacer, next_sibling);
      obj.create();
      obj.setColor();
      return obj;
    }
    create() {
      this.element.style.height = `${this.navigation.height}px`;
      this.height = this.navigation.height;
    }
    setColor() {
      if (!this.next_sibling)
        return false;
      const background_color = window.getComputedStyle(this.next_sibling).getPropertyValue("background-color");
      this.element.style.backgroundColor = background_color;
    }
    updateHeight() {
      const self = this;
      window.Store.components.navigation.obj.elements.nav.element.addEventListener(getTransitionEndEventName(), function _listener() {
        self.navigation.height = window.Store.components.navigation.obj.navHeight;
        self.element.style.height = `${self.navigation.height}px`;
        self.height = self.navigation.height;
        window.Store.scrollbar.updateAfterTransitionEnd(self.element);
        window.Store.components.navigation.obj.elements.nav.element.removeEventListener(getTransitionEndEventName(), _listener, true);
        if (window.Store.scrollbar)
          window.Store.scrollbar.update();
      }, true);
    }
  };
  function render() {
    window.Store.components.spacer.obj = Spacer.init();
  }
  window.Store.components.spacer = {
    obj: null,
    render: null
  };
  window.Store.components.spacer.render = render;
})();
